import Homepage from "./components/Homepage";
import "./App.css";

function App() {
  return (
    <div className="App">
      <h1>Weather App</h1>
      <Homepage />
    </div>
  );
}

export default App;
